/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {useTranslation} from 'react-i18next'
import config from '../../../../services/config.json'
import {IsPrivilege} from '../../../../services/Utils'
export function AsideMenuMain() {
  const intl = useIntl()
  const {t} = useTranslation()
  const debugMode = config.debug
  return (
    <>
      {debugMode == 'test1' ? (
        <AsideMenuItem to='/builder' icon='switch' title='Layout Builder' fontIcon='bi-layers' />
      ) : null}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            {t('common:Dashboard')}
          </span>
        </div>
      </div>

      <AsideMenuItem
        to='/dashboard'
        icon='color-swatch'
        title='Хянах самбар'
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItemWithSub to='/product-tatlaga' title='Бараа' fontIcon='bi-archive' icon='award'>
        <AsideMenuItem to='/product-tatlaga' title='Тэнжээ, татлага' hasBullet={true} />
        <AsideMenuItem to='/product-cran' title='Кран' hasBullet={true} />
        <AsideMenuItem to='/product-sambar' title='Самбар, тэмдэг' hasBullet={true} />
        <AsideMenuItem to='/product-ondriin' title='Өндрийн хамгаалах хэрэгсэл' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub to='/sambar-price' title='Үнэ' fontIcon='bi-archive' icon='award'>
        <AsideMenuItem to='/sambar-price' title='Самбар, тэмдэг үнэ' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub to='/customer' title='Харилцагч' fontIcon='bi-archive' icon='award'>
        <AsideMenuItem to='/customer' title='Харилцагчийн жагсаалт' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub to='/order' title='Захиалга' fontIcon='bi-archive' icon='award'>
        <AsideMenuItem to='/orders/all' title='Захиалгын жагсаалт' hasBullet={true} />
        <AsideMenuItem to='/cranorders/all' title='Кран үнийн санал' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub to='/privilege' title='Эрх' fontIcon='bi-archive' icon='award'>
        <AsideMenuItem to='/privilege/employeelist' title='Хэрэглэгчийн жагсаал' hasBullet={true} />
        <AsideMenuItem to='/privilege/privgrouplist' title='Эрхийн бүлэг' hasBullet={true} />
        <AsideMenuItem to='/privilege/privlist' title='Эрх' hasBullet={true} />
      </AsideMenuItemWithSub>
      {/* {IsPrivilege('employee-getallemployee-POST') ? (
        <AsideMenuItemWithSub
          to='/employee'
          title={t('main:menu.employee')}
          fontIcon='bi-archive'
          icon='people'
        >
          <AsideMenuItem to='/employee' title={t('main:menu.employeelist')} hasBullet={true} />
          <AsideMenuItem
            to='/privilege/privgrouplist'
            title={t('main:menu.privgrouplist')}
            hasBullet={true}
          />
          <AsideMenuItem
            to='/privilege/privlist'
            title={t('main:menu.privlist')}
            hasBullet={true}
          />
        </AsideMenuItemWithSub>
      ) : null} */}
      {/* {IsPrivilege('menu-news') ? (
        <AsideMenuItemWithSub to='/news' title='Мэдээ' fontIcon='bi-archive' icon='element-plus'>
          <AsideMenuItem to='/news' title='Мэдээ' hasBullet={true} />
        </AsideMenuItemWithSub>
      ) : null} */}
      {/* {IsPrivilege('menu-feedback') ? ( */}
      {/* <AsideMenuItemWithSub
        to='/feedback'
        title={t('main:menu.feedback')}
        fontIcon='bi-archive'
        icon='message-question'
      >
        <AsideMenuItem to='/feedback' title={t('main:menu.feedback')} hasBullet={true} />
      </AsideMenuItemWithSub> */}

      {/* ) : null} */}
      {debugMode == 'test1' ? (
        <>
          <AsideMenuItemWithSub
            to='/crafted/pages'
            title='Pages'
            fontIcon='bi-archive'
            icon='element-plus'
          >
            <AsideMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
              <AsideMenuItem
                to='/crafted/pages/profile/overview'
                title='Overview'
                hasBullet={true}
              />
              <AsideMenuItem
                to='/crafted/pages/profile/projects'
                title='Projects'
                hasBullet={true}
              />
              <AsideMenuItem
                to='/crafted/pages/profile/campaigns'
                title='Campaigns'
                hasBullet={true}
              />
              <AsideMenuItem
                to='/crafted/pages/profile/documents'
                title='Documents'
                hasBullet={true}
              />
              <AsideMenuItem
                to='/crafted/pages/profile/connections'
                title='Connections'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>

            <AsideMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
              <AsideMenuItem
                to='/crafted/pages/wizards/horizontal'
                title='Horizontal'
                hasBullet={true}
              />
              <AsideMenuItem
                to='/crafted/pages/wizards/vertical'
                title='Vertical'
                hasBullet={true}
              />
            </AsideMenuItemWithSub>
          </AsideMenuItemWithSub>
          <AsideMenuItemWithSub
            to='/crafted/accounts'
            title='Accounts'
            icon='profile-circle'
            fontIcon='bi-person'
          >
            <AsideMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
            <AsideMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
          </AsideMenuItemWithSub>
          <AsideMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>
            <AsideMenuItem to='/error/404' title='Error 404' hasBullet={true} />
            <AsideMenuItem to='/error/500' title='Error 500' hasBullet={true} />
          </AsideMenuItemWithSub>
          <AsideMenuItemWithSub
            to='/crafted/widgets'
            title='Widgets'
            icon='element-11'
            fontIcon='bi-layers'
          >
            <AsideMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
            <AsideMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
            <AsideMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
            <AsideMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
            <AsideMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
            <AsideMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
          </AsideMenuItemWithSub>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
            </div>
          </div>
          <AsideMenuItemWithSub
            to='/apps/chat'
            title='Chat'
            fontIcon='bi-chat-left'
            icon='message-text-2'
          >
            <AsideMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
            <AsideMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
            <AsideMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
          </AsideMenuItemWithSub>
          <AsideMenuItem
            to='/apps/user-management/users'
            icon='shield-tick'
            title='User management'
            fontIcon='bi-layers'
          />
        </>
      ) : null}
    </>
  )
}
